/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './CustomButton.scss';
import { Spinner } from '@chakra-ui/react';

// https://stackoverflow.com/questions/75753799/is-there-an-elegant-way-to-mix-custom-props-and-native-props-for-a-react-ts-comp
interface ButtonProps {
  label: string,
  buttonColor: string,
  testId: string,
  spinnerId: string | undefined,
  buttonType: 'submit' | 'button',
  buttonProps: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >;
  size: 'small' | 'medium'
}

// https://kevinyckim33.medium.com/jsx-spread-operator-component-props-meaning-3c9bcadd2493
export default function CustomButton({ buttonProps, ...props }: ButtonProps) {
  const {
    buttonType,
    buttonColor,
    label,
    testId,
    spinnerId,
    size,
  } = props;
  // console.log(buttonColor);
  return (
    <button
      data-testid={testId}
      type={buttonType === 'button' ? 'button' : 'submit'}
      className={`btn-${buttonColor} btn-${size} btn`}
      {...buttonProps}
    >
      <Spinner id={spinnerId} className="spinner-off" size="md" marginRight="1rem" />
      {label}
    </button>
  );
}
